var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"not-found"},[_c('div',{staticClass:"container"},[_c('section-header',{attrs:{"level":"1","text":"Страница не найдена"}}),_c('btn',{attrs:{"to":"/"}},[_c('span',[_vm._v("Вернуться на главную")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }